import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
const SocialMediaStrategy = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [socialMediaStrategy, setSocialMediaStrategy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const [showOtherInputs, setShowOtherInputs] = useState({
        primaryGoals: false,
    });

    // Form state
    const [formData, setFormData] = useState({
        primaryGoals: [],
        social_media_platforms: '',
        posting_frequency: '',
        best_performing_content_types: '',
        content_pillars: '',
        hashtags_branded: '',
        cta_guidelines: '',
        crisis_management_plan: ''
    });

    const fetchsocialMediaStrategy = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-socialmedia/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setSocialMediaStrategy(response.data);
            setFormData({
                primaryGoals: response.data.primaryGoals || [],
                social_media_platforms: response.data.social_media_platforms || '',
                posting_frequency: response.data.posting_frequency || '',
                best_performing_content_types: response.data.best_performing_content_types || '',
                content_pillars: response.data.content_pillars || '',
                hashtags_branded: response.data.hashtags_branded || '',
                cta_guidelines: response.data.cta_guidelines || '',
                crisis_management_plan: response.data.crisis_management_plan || '',
            });
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchsocialMediaStrategy();
        }
    }, [brandId, accessToken]);


    const handleEdit = () => {
        setEditDialogVisible(true);
    };

    // Handle checkbox change
    const handleCheckboxChange = (e, field) => {
        const { value, checked } = e.target;
        setFormData((prev) => {
            let updatedValues = [...prev[field]];

            if (checked) {
                updatedValues.push(value);
            } else {
                updatedValues = updatedValues.filter(item => item !== value);
            }

            if (value === "Other") {
                setShowOtherInputs((prev) => ({ ...prev, [field]: checked }));
            }

            return { ...prev, [field]: updatedValues };
        });
    };

    // Handle "Other" input field change
    const handleOtherInputChange = (e, field) => {
        const { value } = e.target;
        setFormData((prev) => {
            let updatedValues = prev[field].filter(item => typeof item !== "object");

            if (value.trim()) {
                updatedValues.push({ Other: value });
            }

            return { ...prev, [field]: updatedValues };
        });
    };


    const handleSocialMediaPlatformsChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handleSubmit = async () => {
        setSubmitLoading(true);
        try {
            const response = await axios.put(`${config.apiBASEURL}/BrandBookRoutes/brand-socialMediaStrategy/${socialMediaStrategy.sm_strategy_id}/${brandId}`, formData, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchsocialMediaStrategy(); // Refresh data after update
                }, 5000);
            }
        } catch (err) {
            console.error("Error updating brand identity:", err);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false);
        }
    };


    useEffect(() => {
        setShowOtherInputs({
            primaryGoals: formData.primaryGoals.some(el => typeof el === "object")
        });
    }, [formData]); // Update when formData changes


    if (loading) return <p>Loading...</p>;


    // Function to extract values from array (handling "Other" case)
    const formatArrayData = (data) =>
        data
            .map(item => (typeof item === "string" ? item : item.Other)) // Extracts "Other" key values
            .join(", ");
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Social Media Strategy
                        <small className="text-danger d-block mt-1" style={{fontSize: '12px'}}>
                            Last Update: {socialMediaStrategy?.updatedAt ? new Date(socialMediaStrategy.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEdit}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Primary Goals:</th>
                                <td>
                                    {formatArrayData(socialMediaStrategy?.primaryGoals)}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Social Media Platforms:</th>
                                <td>
                                    {socialMediaStrategy?.social_media_platforms}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Posting Frequency:</th>
                                <td>
                                    {socialMediaStrategy?.posting_frequency}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Best performing Content Types:</th>
                                <td>
                                    {socialMediaStrategy?.best_performing_content_types}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Content Pillars:</th>
                                <td>
                                    {socialMediaStrategy?.content_pillars}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Hashtags:</th>
                                <td>
                                    {socialMediaStrategy?.hashtags_branded}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">CTA Guidelines:</th>
                                <td>
                                    {socialMediaStrategy?.cta_guidelines}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Crisis Management Plan:</th>
                                <td>
                                    {socialMediaStrategy?.crisis_management_plan}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Social Media Strategy"
                visible={editDialogVisible}
                style={{ width: '60vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row className="mx-0" style={{ height: '70vh', overflowY: 'auto' }}>
                    <Col md={12} lg={12} className="mb-4 pe-lg-5">
                        <Form.Label>Primary Goals for Social Media</Form.Label>
                        <div className="d-flex flex-wrap gap-4 mt-1 pt-4 border-top">
                            {["Brand Awareness", "Engagement", "Lead Generation", "Sales Conversion", "Community Building", "Customer Support", "Thought Leadership"].map((goal, index) => (
                                <div key={index} className="d-flex align-items-center">
                                    <Checkbox
                                        inputId={`goal-${index}`}
                                        value={goal}
                                        onChange={(e) => handleCheckboxChange(e, "primaryGoals")}
                                        checked={formData.primaryGoals.some(el => el === goal)}
                                    />
                                    <label htmlFor={`goal-${index}`} className="ms-2">{goal}</label>
                                </div>
                            ))}

                            {/* "Other" checkbox */}
                            <div className="d-flex align-items-center">
                                <Checkbox
                                    inputId="goal-other"
                                    value="Other"
                                    onChange={(e) => handleCheckboxChange(e, "primaryGoals")}
                                    checked={showOtherInputs.primaryGoals}
                                />
                                <label htmlFor="goal-other" className="ms-2">Other</label>
                            </div>

                            {/* Input field for "Other" */}
                            {showOtherInputs.primaryGoals && (
                                <div className="w-100">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter other goal"
                                        value={formData.primaryGoals.find(el => typeof el === "object")?.Other || ""}
                                        onChange={(e) => handleOtherInputChange(e, "primaryGoals")}
                                    />
                                </div>
                            )}
                        </div>
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Key Social Media Platforms & Handles</Form.Label>
                        <Form.Control as="textarea" name="social_media_platforms" value={formData.social_media_platforms} onChange={handleSocialMediaPlatformsChange} rows={4} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Posting Frequency <sub>(Per Platform)</sub></Form.Label>
                        <Form.Control as="textarea" name="posting_frequency" value={formData.posting_frequency} onChange={handleSocialMediaPlatformsChange} rows={4} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Best-Performing Content Types <sub>(E.g., Reels, Carousels, Infographics, Memes, Stories, Polls, UGC, etc.)</sub></Form.Label>
                        <Form.Control as="textarea" name="best_performing_content_types" value={formData.best_performing_content_types} onChange={handleSocialMediaPlatformsChange} rows={4} className="h-auto" />

                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Content Pillars <sub>(Define the main themes of content, e.g., Education, Inspiration, Promotion, Community, etc.)</sub></Form.Label>
                        <Form.Control as="textarea" name="content_pillars" value={formData.content_pillars} onChange={handleSocialMediaPlatformsChange} rows={5} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Hashtags Strategy</Form.Label>
                        <Form.Control as="textarea" name="hashtags_branded" value={formData.hashtags_branded} onChange={handleSocialMediaPlatformsChange} rows={4} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>CTA  Guidelines <sub>(Call-To-Action)</sub></Form.Label>
                        <Form.Control as="textarea" name="cta_guidelines" value={formData.cta_guidelines} onChange={handleSocialMediaPlatformsChange} rows={4} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Crisis Management Plan <sub>(How to handle PR issues or negative feedback online)</sub></Form.Label>
                        <Form.Control as="textarea" name="crisis_management_plan" value={formData.crisis_management_plan} onChange={handleSocialMediaPlatformsChange} rows={5} className="h-auto" />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};


export default SocialMediaStrategy;
